import pageTypes from 'apps/analytics/utils/pageTypes';
import SectionType from 'apps/catalogue/models/SectionType';
import analyticsSectionTypes from 'apps/analytics/utils/analyticsSectionTypes';
import containerTypes from 'apps/analytics/utils/containerTypes';

const MERCHANDISING_BETA_FEATURE = 'MERCHANDISING_RECOMMENDATIONS';

const betaFeaturesContain = (betaFeatures, searchedBetaFeature) => betaFeatures.indexOf(searchedBetaFeature) > -1;

const SECTIONS = {
  [SectionType.FEATURED]: () => analyticsSectionTypes.FEATURED,
  [SectionType.FEATURED_AFTER_FAVS]: () => analyticsSectionTypes.FEATURED,
  [SectionType.SUBSCRIPTIONS]: () => analyticsSectionTypes.OTHER,
  [SectionType.OTHER]: () => analyticsSectionTypes.OTHER,
  [SectionType.SUGGESTED_ORDER]: () => analyticsSectionTypes.SUGGESTED_ORDER,
  [SectionType.ON_OFFER]: ({ pageType }) => (pageType === pageTypes.OFFERS_LANDING
    ? analyticsSectionTypes.TOP_OFFERS
    : analyticsSectionTypes.ON_OFFER),
  [SectionType.FAVOURITES]: ({ pageType }) => {
    if (pageType === pageTypes.HOMEPAGE) {
      return analyticsSectionTypes.FAVOURITES;
    }
    if (pageType === pageTypes.OFFERS_LANDING || pageType === pageTypes.OFFERS_PRODUCTS) {
      return analyticsSectionTypes.OFFERS_ON_YOUR_FAVOURITES;
    }
    return analyticsSectionTypes.NA;
  },
  [SectionType.RECOMMENDATIONS]: () => analyticsSectionTypes.RECOMMENDED,
  [SectionType.NEW]: () => analyticsSectionTypes.NEW,
  [SectionType.HYRO_ITEMS]: () => analyticsSectionTypes.HAVE_YOU_RUN_OUT_OF,
  [SectionType.FORGOTTEN_ITEMS]: () => analyticsSectionTypes.DID_YOU_FORGET,
  [SectionType.INCOMPLETE_OFFERS]: () => analyticsSectionTypes.INCOMPLETE_OFFERS_IN_YOUR_TROLLEY,
  [SectionType.OFFERS_ON_FAVS]: () => analyticsSectionTypes.OFFERS_ON_YOUR_FAVOURITES,
  [SectionType.TOP_OFFERS_BESTSELLERS]: () => analyticsSectionTypes.TRY_SOMETHING_NEW,
  [SectionType.TRY_SOMETHING_NEW]: () => analyticsSectionTypes.TRY_SOMETHING_NEW,
  [SectionType.FLASH_SALES]: () => analyticsSectionTypes.FLASH_SALES,
  [SectionType.PERSONALISED_COUPONS]: () => analyticsSectionTypes.PERSONALISED_COUPONS,
  [SectionType.SPECIAL_OFFERS]: ({ betaFeatures }) =>
    (betaFeaturesContain(betaFeatures, MERCHANDISING_BETA_FEATURE)
      ? analyticsSectionTypes.RECOMMENDATIONS_COW
      : analyticsSectionTypes.SPECIAL_OFFERS_YOU_MIGHT_LIKE
    ),
};

/**
 * Return Analytics section name based on page type, section type, container type and betafeatures
 * @param {Object} arg0 Named parameters object (see below)
 * @param {string} arg0.pageType Type of the page
 * @param {string} arg0.sectionAttributesType Type of the section
 * @param {Object} [arg0.containerType=containerTypes.REGULAR] Type of the container
 * @param {Array} [arg0.betaFeatures=[]] Array of betafeatures
 * @returns {analyticsSectionTypes}
 */
export const getAnalyticsSection = ({
  pageType, sectionAttributesType, containerType = containerTypes.REGULAR, betaFeatures = [],
}) => {
  switch (containerType) {
    case containerTypes.RECOMMENDED: {
      return analyticsSectionTypes.RECOMMENDED_SIDEBAR;
    }
    case containerTypes.FEATURED: {
      return analyticsSectionTypes.SPONSORED;
    }
    case containerTypes.SIMILAR_PRODUCTS:
    case containerTypes.ALTERNATIVES: {
      return analyticsSectionTypes.ALTERNATIVES;
    }
    case containerTypes.YOU_MIGHT_LIKE: {
      return analyticsSectionTypes.YOU_MIGHT_LIKE;
    }
    default:
      if (pageType === pageTypes.HEALTHIFY) {
        return analyticsSectionTypes.HEALTHIFY;
      }
      return SECTIONS[sectionAttributesType]
        ? SECTIONS[sectionAttributesType]({ pageType, betaFeatures })
        : analyticsSectionTypes.NA;
  }
};
